module.exports = __webpack_public_path__ + "img/generator2.4861c986.png";